import { userSession } from './userSession.js';

export const saveEventToUser = async (userId, eventId) => {
  try {
    // Get userId from session if not provided
    const currentUserId = userId || userSession.getUserId();
    if (!currentUserId) {
      throw new Error('No user ID available');
    }

    const response = await fetch('https://r7ej0e9i28.execute-api.ap-southeast-2.amazonaws.com/dev/saveEvent', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId: currentUserId,
        eventId
      })
    });

    const data = await response.json();
    if (!response.ok) {
      console.error('Save event failed:', data);
      throw new Error(data.message || 'Failed to save event');
    }

    return {
      success: true,
      message: data.message,
      alreadySaved: data.alreadySaved
    };
  } catch (error) {
    console.error('Error saving event:', {
      error,
      errorMessage: error.message,
      errorStack: error.stack,
      userId,
      eventId,
      userSession: {
        isLoggedIn: userSession.isLoggedIn(),
        hasUser: !!userSession.getUser(),
        userId: userSession.getUserId()
      }
    });
    throw error;
  }
}; 